import { backToTop } from './backToTop.js';
import { fetchPostWebmentionCount } from './fetchPostWebmentionCount.js';

if (document.getElementById('webmention')) {
	fetchPostWebmentionCount();
}

backToTop();
